import { render, staticRenderFns } from "./claim.vue?vue&type=template&id=53c96c7d&scoped=true"
import script from "./claim.vue?vue&type=script&lang=js"
export * from "./claim.vue?vue&type=script&lang=js"
import style0 from "./claim.vue?vue&type=style&index=0&id=53c96c7d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c96c7d",
  null
  
)

export default component.exports